export default {
    getSubdomain() {
        // eslint-disable-next-line no-useless-escape
        const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
        const subdomain = domain.split('.');
        return subdomain[0];
    }
}